import { ordemServicoApi } from '../clients/AxiosClients'

const cadastrarOrdemDeServicoDePilha = async (data) => {
	return ordemServicoApi.post('/ordemdeservicodepilha/cadastrar-ordem-de-servico-de-pilha', data)
}

const buscarPlanejamentoOrdemDeServicoDePilha = async (idOrdemDeServico) => {
	return ordemServicoApi.get(
		`ordemdeservicodepilha/buscar-informacoes-de-ordem-de-servico-de-pilha?ordemDeServicoId=${idOrdemDeServico}`,
	)
}

const editarOrdemDeServicoDePilha = async (idOrdemDeServico, data) => {
	return ordemServicoApi.put(
		`ordemdeservicodepilha/editar-ordem-de-servico-de-pilha?ordemDeServicoDePilhaId=${idOrdemDeServico}`,
		data,
	)
}

export {
	buscarPlanejamentoOrdemDeServicoDePilha,
	cadastrarOrdemDeServicoDePilha,
	editarOrdemDeServicoDePilha,
}
